module.exports = __webpack_public_path__ + "img/solutionBj.8722d09c.jpg";